import { findNodeById } from '@sonifi/wb-tree/utils/helper';
import { getIdFromUrl } from '@sonifi/wb-core/utils/parseHelper';
import { uniqueId } from 'lodash';

const checkNodeForDeletedMedia = ({ node, mediaDependencies }) => {
  const hasDeletedContent = node.subject?.image?.find(
    (img) => !mediaDependencies.find((imgDep) => imgDep.uri === img.image),
  );
  return !!hasDeletedContent;
};

const getChildrenMapped = ({ children, embedded, mediaDependencies }) => {
  children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      getChildrenMapped({
        children: children[index].children,
        embedded,
        mediaDependencies,
      });
    }
    const auxCh = {
      ...ch,
      subject: embedded[ch.subject],
      indicatorImage: {
        showIcon: embedded[ch.subject]?.ird_option_sets?.length > 0,
        showTooltip: embedded[ch.subject]?.ird_option_sets?.length > 0,
      },
    };
    children[index] = {
      ...auxCh,
      id: uniqueId(`${Date.now()}_`),
      subject: {
        ...auxCh.subject,
        isZombie: false,
        hasDeletedContent: checkNodeForDeletedMedia({
          node: auxCh,
          mediaDependencies,
        }),
        image: auxCh.subject.image.map((image) => ({
          ...image,
          file_uri: mediaDependencies.find((media) => media.uri === image.image)
            ?.files[0]?.file_uri,
        })),
      },
    };
  });
  return children;
};

export const getIrdMenuMapped = ({
  data,
  group,
  mediaDependencies,
  revenueCenterUri,
}) => {
  const menuRevenueCenter = data.objects.find(
    (m) => m.revenue_center === revenueCenterUri,
  );
  const children = getChildrenMapped({
    children: menuRevenueCenter.menu.children,
    embedded: data._embedded,
    mediaDependencies,
  });

  const menu = {
    ...menuRevenueCenter.menu,
    id: menuRevenueCenter.menu?.id || uniqueId(`${Date.now()}_`),
    group,
    children,
    subject: data._embedded[menuRevenueCenter.menu.subject],
    indicatorImage: {
      showIcon:
        data._embedded[menuRevenueCenter.menu.subject]?.ird_option_sets
          ?.length > 0,
      showTooltip:
        data._embedded[menuRevenueCenter.menu.subject]?.ird_option_sets
          ?.length > 0,
    },
  };

  const irdMenu = {
    ...menuRevenueCenter,
    menu,
  };
  return irdMenu;
};

const getChildrenOptionSets = ({ children, optionSets = [] }) => {
  children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      getChildrenOptionSets({
        children: children[index].children,
        optionSets,
      });
    }
    if (ch.subject?.ird_option_sets?.length) {
      const childOptionSets = ch.subject?.ird_option_sets
        .filter((osUri) => optionSets.every((os) => os.uri !== osUri)) // Don't add repeated
        .map((osUri) => ({
          id: getIdFromUrl({ url: osUri, parseToInt: true }),
          uri: osUri,
        }));
      optionSets.push(...childOptionSets);
    }
  });
  return optionSets;
};

export const getIrdOptionsSetsDependenciesFromMenu = (menu) => {
  const optionSets = getChildrenOptionSets({
    children: menu.children,
  });

  return optionSets;
};

export const getInicialNode = ({ id, menu }) => {
  // node Id cuold be String or Int
  const nodeId = id ? (String(id).includes('_') ? id : parseInt(id)) : null;
  const node = findNodeById({ menu, nodeId }) || menu;
  return node;
};
